import React from 'react';
import { useAuth } from '../../../hooks/useAuth';

const SocialLogin = () => {
  const { loginWithGoogle, isLoading } = useAuth();

  const handleGoogleLogin = async () => {
    await loginWithGoogle();
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-card text-muted-foreground">Or continue with</span>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3">
        <button
          onClick={handleGoogleLogin}
          disabled={isLoading}
          className="flex items-center justify-center gap-2 p-3 border border-border rounded-lg transition-smooth hover:bg-[#4285F4]/10 hover:text-[#4285F4] hover:border-[#4285F4]/30"
          aria-label="Sign in with Google"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" aria-hidden="true">
            <g fill="none">
              <path d="M17.64 9.2c0-.63-.06-1.26-.18-1.86H9v3.52h4.84c-.21 1.14-.84 2.1-1.8 2.74v2.27h2.9c1.7-1.57 2.7-3.89 2.7-6.67z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.47-.8 5.96-2.17l-2.9-2.27c-.81.54-1.85.86-3.06.86-2.35 0-4.34-1.58-5.05-3.7H.9v2.33C2.38 15.98 5.46 18 9 18z" fill="#34A853"/>
              <path d="M3.95 10.73a5.42 5.42 0 010-3.46V4.94H.9A9 9 0 000 9c0 1.45.35 2.83.9 4.06l3.05-2.33z" fill="#FBBC05"/>
              <path d="M9 3.54c1.32 0 2.52.45 3.46 1.33l2.59-2.59C13.47.92 11.43 0 9 0 5.46 0 2.38 2.02.9 4.94l3.05 2.33C4.66 5.12 6.65 3.54 9 3.54z" fill="#EA4335"/>
            </g>
          </svg>
          <span className="font-medium">Continue with Google</span>
        </button>
      </div>
    </div>
  );
};

export default SocialLogin;